import { Route } from "react-router-dom"
import PrivacyPolicy from "./PrivacyPolicy"
import TOS from "./TOS"
import PasswordReset from "./PasswordReset"

export const commonRoutes =[
        <Route path="privacy-policy" element={<PrivacyPolicy />} />,
        <Route path="password_reset/:token" element={<PasswordReset />} />,
        <Route path="tos" element={<TOS />} />,
    
]